import { dabFilmsConstants } from "./constants/dabFilmsConstant";

const dabFilmsSave = (id:any, dabFilmsInput: any) => {
	return {
		type: dabFilmsConstants.DABFilmsSaveRequest,
		input: {dabFilmsInput: dabFilmsInput, id: id}
	};
};

const dabFilmsGetByfilter = (dabFilmsInput: any=null) => {
	return {
		type: dabFilmsConstants.DABFilmsGetByfilterRequest,
		input: dabFilmsInput
	};
};

const dabFilmsGetDetail = (id: any) => {
	return {
		type: dabFilmsConstants.DABFilmsDetailRequest,
		input: { id: id }
	};
};

const dabFilmsDelete = (id: any) => {
	return {
		type: dabFilmsConstants.DABFilmsDeleteRequest,
		input: id
	};
};

const updatedabFilmsVideoStatus = (data: any) => {
	return {
		type: dabFilmsConstants.DABFilmsVideoStatusUpdateRequest,
		input: data
	};
};

export const dabFilmsAction = {
	dabFilmsGetByfilter,
	dabFilmsGetDetail,
	dabFilmsDelete,
	updatedabFilmsVideoStatus,
	dabFilmsSave
}